import React from "react"
import { Link } from "@carrotfertility/carotene-core"
import { useToggle } from "#/utils/Hooks"
import { useRichTextContext } from "#/services/contentful/shared/rich-text"
import { ContentfulDialog } from "#/services/contentful/shared/contentful-modal"
import { ContentfulArrowLink } from "#/services/contentful/shared/contentful-arrow-link"
import { ModalContentContext } from "#/services/contentful/shared/modal-content-context"
import type { ModalNode } from "../renderer/types"
import { ContentList } from "./content-item"

export function ModalContent({ content }: { content: ModalNode }) {
  const [showModal, toggleShowModal] = useToggle(false)
  const { isInRichText } = useRichTextContext()

  return (
    <>
      {isInRichText ? (
        <Link
          sx={{
            textAlign: "start",
            verticalAlign: "baseline"
          }}
          color="inherit"
          component="button"
          onClick={toggleShowModal}
        >
          {content.linkText}
        </Link>
      ) : (
        <ContentfulArrowLink component="button" onClick={toggleShowModal}>
          {content.linkText}
        </ContentfulArrowLink>
      )}
      <ContentfulDialog title={content.title} open={showModal} onClose={toggleShowModal}>
        <ModalContentContext.Provider value={{ isModalContent: true }}>
          <ContentList contents={content.content} />
        </ModalContentContext.Provider>
      </ContentfulDialog>
    </>
  )
}
